import React from "react";
import styles from "./style.module.css";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FaGift } from 'react-icons/fa6';

const NumberCard = ({ numberListing, handleContactClick }) => {
  const {
    msisdn,
    includedMinutes,
    includedDataMb,
    paymentType,
    price,
  } = numberListing;

  const formatGiftText = (minutes, dataMb) => {
    const parts = [];
    
    if (dataMb) {
      if (dataMb >= 1000) {
        const gbValue = (dataMb / 1000).toFixed(1).replace(/\.0$/, "");
        parts.push(`${gbValue} GB`);
      } else {
        parts.push(`${dataMb} MB`);
      }
    }
    
    if (minutes) {
      parts.push(`${minutes} dəq.`);
    }
    
    return parts.length > 0 ? parts.join(", ") : "Hədiyyəsiz";
  };

  const formattedNumber = msisdn.replace(/(\d{2})(\d{3})(\d{2})(\d{2})/, "$1 $2 $3 $4");
  const giftText = formatGiftText(includedMinutes, includedDataMb);
  const typeLabel = paymentType === "postpaid" ? "Fakturalı" : "Fakturasız";
  const formattedPrice = `${price} ₼`;
  const hasGifts = includedMinutes || includedDataMb;

  return (
    <div className={styles.card}>
      <div className={styles.msisdn}>
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="tooltip-msisdn">{formattedNumber}</Tooltip>}
        >
          <span className={`${styles.pointerCursor} ${styles.ellipsis}`}>{formattedNumber}</span>
        </OverlayTrigger>
      </div>

      <div className={styles.gift}>
        <FaGift />
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="tooltip-gift">{giftText}</Tooltip>}
        >
          <span className={`${hasGifts ? `${styles.giftText} ${styles.hasGifts}` : styles.giftText} ${styles.ellipsis}`}>
            {giftText}
          </span>
        </OverlayTrigger>
      </div>

      <div className={styles.type}>
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="tooltip-type">{typeLabel}</Tooltip>}
        >
          <span className={`${styles.pointerCursor} ${styles.ellipsis}`}>{typeLabel}</span>
        </OverlayTrigger>
      </div>

      <div className={styles.price}>
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="tooltip-price">{formattedPrice}</Tooltip>}
        >
          <span className={`${styles.pointerCursor} ${styles.ellipsis}`}>{formattedPrice}</span>
        </OverlayTrigger>
      </div>

      <div className={styles.action}>
        <button 
          onClick={() => handleContactClick(numberListing)} 
          className={styles.contactButton}
        >
          Sifariş et
        </button>
      </div>
    </div>
  );
};

export default NumberCard;